import React, { useEffect, useState, createRef } from 'react';
import Notification from './Notification';

const Notifications = () => {
  const notificationsRef = createRef();
  const [hasOpenedNotifications, setHasOpenedNotifications] = useState(false);
  const [notificationData, setNotificationData] = useState({
    notification_list: [],
    last_opened_at: 0,
    fetched_at: 0,
    new_notifications: false
  });

  // API requests
  const fetchNotifications = () => {
    fetch('/notifications')
      .then((res) => res.json())
      .then((res) => setNotificationData(res));
  };

  const postNotificationsOpen = () => {
    fetch('/notifications/open', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ fetched_at: notificationData.fetched_at })
    });
  };

  // Functions
  const setupButtonListener = () => {
    const notificationButton = $('.js-notifications-btn');
    const notificationWrapper = $('.js-notifications-wrapper');
    const notificationList = $(notificationsRef.current);
    notificationButton.on('click', () => {
      setHasOpenedNotifications(true);
      notificationList.slideToggle('fast');

      $('body').on('click', (e) => {
        if (!notificationWrapper[0].contains(e.target)) {
          notificationList.slideUp('fast');
        }
      });
    });
  };

  const displayRedDot = () => {
    const {
      notification_list: notificationList,
      last_opened_at: lastOpenedAt
    } = notificationData;

    let newNotificationCount = 0;
    notificationList.forEach((notification) => {
      if (notification.updated_at > lastOpenedAt) {
        newNotificationCount += 1;
      }
    });

    if (newNotificationCount === 0) return;

    // Keep numbers small
    if (newNotificationCount > 9) {
      newNotificationCount = '9+';
    }

    $('.js-notifications-btn').addClass('Notifications-button--new');
    $('.js-notifications-dot').text(newNotificationCount);
  };

  // Hooks
  useEffect(() => {
    fetchNotifications();
    setupButtonListener();
  }, []);

  useEffect(() => {
    if (notificationData.new_notifications === true) {
      displayRedDot();
    }
  }, [notificationData]);

  useEffect(() => {
    if (hasOpenedNotifications) {
      $('.js-notifications-btn').removeClass('Notifications-button--new');
      postNotificationsOpen();
    }
  }, [hasOpenedNotifications]);

  const {
    notification_list: notificationList,
    last_opened_at: lastOpenedAt,
    fetched_at: fetchedAt
  } = notificationData;

  return (
    <ul ref={notificationsRef} className="Notifications">
      {notificationList.length ? (
        notificationList.map((notification) => (
          <Notification
            notificationItem={notification}
            lastOpenedAt={lastOpenedAt}
            fetchedAt={fetchedAt}
            key={notification.updated_at}
          />
        ))
      ) : (
        <li className="Notification">
          <span className="fw6 pv2">You have no notifications.</span>
        </li>
      )}
    </ul>
  );
};

export default Notifications;
